export class FinraException {
    /* Please note as mix of model + JSON is being used (As existing filter panel / symbol filter / code filter uses JSON),
    main-list.json db_colimn is used to remove duplicate columns from Filter panel => 'Add Filter' box. 
    Please note that it is case sensitive
    For List only "ui_columnname" and "db_columnname" is used */
    id!: number;

    failureCode!: string;
    firmROEID!: string;
    originalJSON!: string ;

    fileID!: number;
    modifiedFlag!: string;
    type!: string;
    catSubmitterID!: string;
    CATReporterIMID!: string;
    reportDate!: string;
    fileName!: string;
    groupName!: string;
    failureDescription!: string;
    actualValue!: string;
    suggestedValue!: string;
    status!: string;
    symbol!: string;
    side!: string;
    price!: string;
    quantity!: string;
    orderID!: string;
    routedOrderID!: string;
    tradeID!: string;
    quoteID!: string;
    quoteMPID!: string;
    eventTimestamp!: string;
    manualFlag!: string;
    destination!: string;
    session!: string;
    severity!: string;
    buyOrderID!: string;
    sellOrderID!: string;
    clientOrderID!: string;
    firmOrderID!: string;
    allocationID!: string;
    representativeInd!: string;
    routeRejectedFlag!: string;
    solicitationFlag!: string;
    createDate!: string;
    lastUpdate!: string;
    user!: string;
    
}
